import { LocalizationString } from '@celito.clients/assets';
import { ButtonTypes } from '@celito.clients/enums';
import { getCoursePageUrl } from '@celito.clients/utils';
import { Link } from 'react-router';

import { ColumnData, RowItem } from '../../../grid-view-new/src/types';
import { CustomButton } from '../../../shared';
import classes from '../reference-selector.module.css';

export const getCoursesSelectorGridColumns = (
  onItemDelete?: (item: RowItem) => void,
  isPreviewTab?: boolean,
  onColumnClick?: ColumnData['onColumnClick']
) => {
  const courseGridColumns: ColumnData[] = [
    {
      name: 'Course ID',
      isResizable: true,
      key: 'label',
      maxWidth: 200,
      minWidth: 100,
      fieldName: 'label',
      onColumnClick,
      showSortIconWhenUnsorted: true,
      onRender: (item: RowItem) => (
        <Link
          to={getCoursePageUrl(item.name, item.version)}
          className={classes.hyperlink}
          target="_blank"
        >
          {item.label}
        </Link>
      ),
    },
    {
      name: 'Course Version',
      isResizable: true,
      key: 'version',
      maxWidth: 120,
      minWidth: 100,
      fieldName: 'version',
      onColumnClick,
      showSortIconWhenUnsorted: true,
    },
    {
      name: 'Course Name',
      isResizable: true,
      key: 'title',
      maxWidth: 200,
      minWidth: 100,
      fieldName: 'title',
      onColumnClick,
      showSortIconWhenUnsorted: true,
    },
    {
      name: 'Course Status',
      isResizable: true,
      key: 'status',
      maxWidth: 120,
      minWidth: 100,
      fieldName: 'status',
      onColumnClick,
      showSortIconWhenUnsorted: true,
    },
    {
      name: 'Document ID',
      isResizable: true,
      key: 'controlledDocumentLabel',
      maxWidth: 200,
      minWidth: 100,
      fieldName: 'controlledDocumentLabel',
      onColumnClick,
      showSortIconWhenUnsorted: true,
    },
    {
      key: 'actions',
      minWidth: 75,
      maxWidth: 100,
      name: LocalizationString.ACTIONS,
      fieldName: 'actions',
      isResizable: true,
      onRender: (item?: RowItem, index?: number, column?: ColumnData) => (
        <CustomButton
          as="button"
          buttonType={ButtonTypes.Destructive}
          customStyles={classes.delete_btn}
          leftIcon="Delete"
          title="Delete"
          onClick={isPreviewTab ? undefined : () => onItemDelete?.(item!)}
          disabled={isPreviewTab}
        />
      ),
    },
  ];
  return courseGridColumns;
};
